import { Controller } from '@hotwired/stimulus';
export default class PageNavbarController extends Controller {
  connect() {}
}
